import React from 'react';
import ReusableDemoPage from "../ReusableDemoPage";
import { noiseConfig } from '../demoConfigs';

const NoiseDemo = () => {
  return <ReusableDemoPage config={noiseConfig} />;
};

export default NoiseDemo;